
































































import Vue from "vue";
import storeHelper from "../../store/store-helper";
import Utils from "@/utils";
import { Membership } from "@/teams";
import UserSelector from "../../components/generic/UserSelector/UserSelector.vue";
import Toolbar from "../../components/toolbar/Toolbar.vue";
import { UserItem } from "@/components/generic/UserSelector/types";

export default Vue.extend({
    name: "AddTeam",
    components: { UserSelector, Toolbar },
    props: {},
    data: function () {
        return {
            submitting: false,
            name: "",
            description: "",
            memberships: [] as UserItem[],
            managers: [String]
        };
    },
    mounted() {
        this.$emit("has-panels", true);
    },
    created() {
        document.title = Utils.getPageTitle(this.$t("teams.addTeam.title") as string, "after");
    },
    methods: {
        cancel() {
            this.$router.back();
        },
        required() {
            return v => !!v || `${this.$t("general.validation.isRequired")}`;
        },
        validateForm() {
            const formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

            return formIsValid;
        },
        async addTeam(e) {
            this.submitting = true;
            try {
                e.preventDefault();
                if (this.validateForm()) {
                    //check that current user is set as member, if not add user
                    let userIsmember =
                        this.memberships.findIndex(m => {
                            return m.assigneeId == this.$user.user_id;
                        }) >= 0;

                    const teamMembers = this.memberships.map(m => {
                        return {
                            user_id: m.type == "user" ? m.assigneeId : null,
                            user_group_id: m.type == "usergroup" ? m.assigneeId : null
                        } as Membership;
                    });

                    if (!userIsmember) {
                        //add user to members
                        teamMembers.push({ user_id: this.$user.user_id, user_group_id: null, name: this.$user.name });
                    }

                    const createTeamResult = await storeHelper.teamsStore.createTeamAsync(this.name, this.description, teamMembers, [
                        this.$user.user_id
                    ]);
                    if (createTeamResult.success) {
                        //Navigate to created team
                        this.$router.push({ name: "Team", params: { teamId: createTeamResult.successData } });
                    } else {
                        if (createTeamResult.errorData) {
                            storeHelper.siteStore.setSnackBarMessage(this.$t(`teams.errorMessages.${createTeamResult.errorData}`).toString(), true);
                        } else {
                            storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                        }
                    }
                }
            } finally {
                this.submitting = false;
            }
        }
    }
});
